import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useRepeatMdRedemptionReport = (params, options = {}) => {
  //todo
  return useQuery(
    ["repeatMdRedemptionReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getRepeatMdRedemptionReport(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
      };
      return composeResponse;
    },
    { ...options, cacheTime: 0 },
  );
};
